import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import lo from 'lodash';
import { NewFuelConsumption } from 'fixtures/TemplateData';
import DataTable from 'components/organisms/DataTable/index';
import ButtonReg from 'components/atoms/Buttons/Button';
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter';
import { selectFormatter } from 'components/molecules/TableFormatters/selectFormatter';
import { EditFormater } from 'components/molecules/TableFormatters/editFormatter';
import { getLookup } from 'Redux/actions/LookupActions';
import { BARGE_LOADING, BARGE_LOADING_FUEL_CONSUMPTION } from 'fixtures/api';
export class ActualLoadingFuelConsumptionForm extends Component {
  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup() {
    const { getLookup, toggleIsLoading } = this.props
    toggleIsLoading(true)
    getLookup(BARGE_LOADING, BARGE_LOADING_FUEL_CONSUMPTION)
    toggleIsLoading(false)
  }

  onChange(val, row, field, rowIndex) {
    const { form: { fuelConsumption: { fuelRobRecords } }, onChange } = this.props
    const { form: { fuelConsumption } } = this.props
    const existing = fuelRobRecords.map(d => d.fuelRobRecord).filter(d => d !== '-')
    if (existing.indexOf(val) > -1){
      return alert('Please choose another fuel rob record')
    }
    const newData = fuelRobRecords.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : val
    } : d)
    fuelConsumption.fuelRobRecords = newData
    if (field === 'liters') {
      fuelConsumption.grandTotal = Number(
        lo.sumBy(fuelConsumption.fuelRobRecords, (record) => Number(record.liters)),
      ).toFixed(3)
    }
    onChange('fuelConsumption', fuelConsumption)
  }

  add() {
    const { form: { fuelConsumption: { fuelRobRecords } }, onChange } = this.props
    const { form: { fuelConsumption } } = this.props
    const newData = [...fuelRobRecords, lo.cloneDeep(NewFuelConsumption)]
    fuelConsumption.fuelRobRecords = newData
    onChange('fuelConsumption', fuelConsumption)
  }

  delete(row, rowIndex) {
    const { form: { fuelConsumption: { fuelRobRecords } }, onChange } = this.props
    const { form: { fuelConsumption } } = this.props
    const newData = fuelRobRecords.filter((d,i) => i !== rowIndex)
    fuelConsumption.fuelRobRecords = newData
    fuelConsumption.grandTotal = Number(
      lo.sumBy(fuelConsumption.fuelRobRecords, (record) => Number(record.liters)),
    ).toFixed(3)
    onChange('fuelConsumption', fuelConsumption)
  }

  render() {
    const { lookups, viewState: { isMobileView }, theme, form: { fuelConsumption } } = this.props

    const config = [
      {
        dataField: 'fuelRobRecord',
        text: 'Fuel Rob Record',
        formatter: selectFormatter,
        formatExtraData: {
          placeholder: 'Select fuel',
          options: lookups.robRecords || [],
          field: 'fuelRobRecord',
          valField: 'name',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
          allowEdit: true,
        },
        footer: 'Grand Total',
        footerStyle: {
          color: theme.mocaGreen
        },
        headerAttrs: { width: 200 },
        editable: false,
        sort: true
      },
      {
        dataField: 'liters',
        text: 'Liters',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter liters',
          type: 'number',
          field: 'liters',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        footer: 'Grand Total',
        footerFormatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{fuelConsumption.grandTotal || 0}</div>
        },
        footerStyle: {
          color: theme.mocaGreen
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { minWidth: 100 },
        formatter: actionFormatter,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowDel: true,
          del: (row, rowIndex) => this.delete.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true
      },
    ]

    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Fuel Consumption
              </Label>
            </HeadContainer>
              <LevelRowContainer>
                <DataTable
                  leftSlot={
                    <ButtonReg
                      btnTxt={'Add'}
                      onClick={() => this.add()}
                      width={'78px'}
                    />
                  }
                  allowSearch={false}
                  rightSlotAlt={true}
                  defaultSize={100}
                  isMobile={isMobileView}
                  dataList={fuelConsumption.fuelRobRecords || []}
                  columnConfig={config}
                />
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BARGE_LOADING) {
    const bargeLoading = state.lookups.data.BARGE_LOADING
    const robRecords = bargeLoading.BARGE_LOADING_FUEL_CONSUMPTION && bargeLoading.BARGE_LOADING_FUEL_CONSUMPTION.find((d) => d.name === 'FUEL_ROB_RECORD')
    lookups.robRecords = robRecords ? robRecords.children.map((d) => ({ name: d.nameDisplay })) : []
  }
  return {
    viewState: state.viewState,
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingFuelConsumptionForm)
  )
);
